/*
 * @Author: lijing
 * @Date: 2022-08-28 14:49:44
 * @Last Modified by: lijing
 * @Last Modified time: 2022-11-11 11:37:47
 */
import React, { Children, FC, useEffect, useState } from "react";
import {
  ArrowUpOutlined,
  DeleteOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  Select,
  Upload,
  Button,
  Switch,
  InputNumber,
  Modal,
  message,
  Space,
  TreeSelect,
  Cascader,
  Radio,
} from "antd";
import { useSelector } from "react-redux";
import { CheckVideo, IVideoProp } from "./checkVideo";
import {
  uploadFile,
  getBase64Image,
  selectTeacher,
  selectTag,
  uploadBase64Image,
  saveCourse,
  querySpecialClassificationData,
  querySubjectTree,
  queryCategoryTree,
  getCourseDefaultImg,
} from "@root/common/service";
import E from "wangeditor";
import { RootState } from "@root/store";
import { handleTreelData } from "@root/common/utils";
const { Option } = Select;
const { TextArea } = Input;
const labelCol = { span: 3 };
const wrapperCol = { span: 20 };

interface IProps {
  courseDetail?: any;
  getCourseList?: (page?: number, params?: object) => Promise<void>;
  setIseditorCourseVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

interface ICourseSectionProp {
  id?: number;
  type: number;
  name: string;
  thirdVideoId: string;
  videoName: string;
}

interface OriginImageProps {
  shortUrl?: string;
  url?: string;
  initImage?: string;
}
let originalImage: OriginImageProps = {}; // 图片原始路径
let base64Image: string | null = null; // 图片原始路径
export const EditorCourse: FC<IProps> = (props) => {
  const { courseDetail } = props;
  const { subjectData, centerClassification } = useSelector(
    (state: any) => state.directionaries
  );
  const { baseUserCategory, isCountyProject } = useSelector(
    (state: RootState) => state.userInfo
  );

  const [isCheckVideoVisible, setIsCheckVideoVisible] = useState(false);
  const [courseSectionList, setCourseSectionList] = useState<
    ICourseSectionProp[]
  >([]);
  const [courseSectionIndex, setCourseSectionIndex] = useState(0);
  const [originalLogo, setOriginalLogo] = useState<string | undefined>();
  const [waterMark, setWaterMark] = useState<boolean>(true);
  const [teacherList, setTeacherList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [courseType, setCourseType] = useState(1);
  const [form] = Form.useForm();
  const [treeData, setTreeData] = useState([]);
  const [courseware] = Form.useForm();
  //学科分类
  const [subjectTree, setSubjectTree] = useState([]);
  // 中心分类
  const [categoryTree, setCategoryTree] = useState([]);
  /**设置专项分类的值 */
  const [category, setCategory] = useState({
    value: "",
    name: "",
  });
  /**是否为播放次数自动设置 */
  const [liveCountAutoSet, setLiveCountAutoSet] = useState(false);
  const handleOk = () => {
    // setIsModalVisible(false);

    // 判断：是否显示审核状态和审核意见
    if (
      (baseUserCategory === "13" || baseUserCategory === "12") &&
      courseDetail &&
      courseDetail.status === 1
    ) {
      Modal.confirm({
        title: "提示",
        content:
          "编辑保存后课程将变为下架状态，上架需要重新进行审核，确认保存？",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            postSaveCourse();
            resolve("操作成功");
          });
        },
      });
    } else {
      postSaveCourse();
    }
  };
  /**
   * 获取学科列表数据
   */
  const getSubjectTree = async () => {
    const { data } = await querySubjectTree();
    setSubjectTree(handleTreelData(data));
  };
  const getCategoryTree = async () => {
    const { data } = await queryCategoryTree();
    console.log("data", data);
    setCategoryTree(handleTreelData(data));
  };
  useEffect(() => {
    getSubjectTree();
    getCategoryTree();
  }, []);
  const handleCancel = () => {
    props.setIseditorCourseVisible(false);
  };

  const onSelectVideoClickHandle = (data: any, index: number) => {
    setCourseSectionIndex(index);
    setIsCheckVideoVisible(true);
  };

  const onSelectVideoCallback = (data: IVideoProp) => {
    setIsCheckVideoVisible(false);
    const newCount = [...courseSectionList];
    newCount[courseSectionIndex] = {
      type: 2,
      name: data.name,
      thirdVideoId: data.thirdVideoId,
      videoName: data.name,
    };
    courseware.setFieldsValue({ courseSectionList: newCount });
    setCourseSectionList(newCount);
  };

  /**
   * 上传图片
   * @param {object} 文件内容
   * @return void
   */
  const uploadChange = async (data: any) => {
    const { file } = data;

    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "image/png"
    ) {
      message.error("请选择正确的文件");
      return false;
    }
    if (file.size / 1024 / 1024 > 2) {
      message.error("请选择正确的文件");
      return false;
    }

    let width = 0;
    let height = 0;

    const checkSize = function () {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = function () {
          resolve({ width: image.width, height: image.height });
        };
      });
    };
    await checkSize()
      .then((res: any) => {
        width = res.width;
        height = res.height;
      })
      .catch((err) => {
        message.error("图片解析错误");
      });

    if (width !== 469 || height !== 300) {
      message.error("请上传宽469px、高300px的图片");
      return false;
    }

    let formData = new FormData();
    formData.append("file", file);
    formData.append("uploadFileType", "image");
    formData.append("folder", "course");

    uploadFile(formData).then((res) => {
      originalImage.shortUrl = res.url;
      originalImage.url = res.shortUrl;

      form.setFieldsValue({ image: res.url });
      getBase64Image(res.shortUrl).then((base) => {
        base64Image = base.data;
        setOriginalLogo(base.data);
        if (waterMark) {
          watermaskChange(true, base.data);
        }
      });
    });
  };

  /**
   * 水印修改
   * @param checked 水印是否打开
   * @param base64 图片base64数据
   * @returns void
   */
  const watermaskChange = async (checked: boolean, base64?: string) => {
    if (checked || base64) {
      const canvas = document.createElement("canvas");
      const ctx: CanvasRenderingContext2D | null = canvas.getContext("2d");

      if (ctx === null) return;

      const image: HTMLImageElement = new Image();
      image.src = base64 || (base64Image as string);
      image.onload = function () {
        canvas.width = image.width;
        canvas.height = image.height;

        ctx.drawImage(image, 0, 0);

        const text = form.getFieldsValue().name;
        if (text) {
          if (text.length > 10) {
            const len = Math.ceil(text.length / 10);
            // 初始位置 = （当前高度 - （行数 * （字高+行距）- 行距）） / 2
            // 微软雅黑实际测量 字高21px 行距5px；最后一行不需要行距
            const init = (image.height - (len * 26.5 - 5)) / 2;
            for (let i = 0; i < len; i++) {
              ctx.font = "normal bold 30px microsoft yahei";
              ctx.fillStyle = "#ffff";
              ctx.textAlign = "center";
              ctx.fillText(
                text.substr(i * 10, 10),
                image.width / 2,
                init + i * 40
              );
            }
          } else {
            ctx.font = "normal bold 30px microsoft yahei";
            ctx.fillStyle = "#ffff";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(text, image.width / 2, image.height / 2);
          }
        }

        setOriginalLogo(canvas.toDataURL("image/jpeg"));
      };
    } else {
      setOriginalLogo(originalImage.url);
    }
  };

  /**
   * 水印修改前触发
   * @param checked 水印是否打开
   */
  const watermaskChangeBefore = (checked?: boolean) => {
    const check = checked || waterMark;
    if (!check) return;

    // 如果base64图片存在 =》 直接修改； 否则转换base64文件
    if (base64Image) {
      watermaskChange(true);
    } else {
      // 判断是否存在原始图片
      if (originalImage.url) {
        getBase64Image(originalImage.url).then((base) => {
          base64Image = base.data;
          watermaskChange(true, base.data);
        });
      }
    }
  };

  /**
   * 课程名称修改触发
   */
  const onNameChange = () => {
    watermaskChangeBefore();
  };

  const postSaveCourse = () => {
    form
      .validateFields()
      .then(async (res) => {
        // 判断课件
        const list = courseware.getFieldValue("courseSectionList");
        if (list.length === 0) {
          message.error("请添加课件");
          return false;
        }

        for (let i = 0; i < list.length; i++) {
          if (!list[i].thirdVideoId) {
            message.error(`请填写课件${i + 1}课件`);
          }
          if (list[i].name === "") {
            message.error(`请填写课件${i + 1}名称`);
            return false;
          }
        }
        // let subjectNameList;
        // if (courseType === 1) {
        //   subjectNameList = subjectData
        //     .filter((item: any) => {
        //       return res.subjectIdList.some((sub: any) => {
        //         return sub === item.id;
        //       });
        //     })
        //     .map((item: any) => {
        //       return item.name;
        //     });
        // }
        if (!Array.isArray(res.teacherIdList)) {
          res.teacherIdList = [res.teacherIdList];
        }

        // 如果初始图片发生过修改则上传新的图片
        if (originalLogo !== originalImage.initImage) {
          let formData = new FormData();
          formData.append("base64Image", originalLogo as string);
          formData.append("folder", "course");
          await uploadBase64Image(formData).then((base) => {
            res.image = base.url;
          });
        }

        res.originalImage = originalImage?.shortUrl;

        // 如果为编辑
        if (courseDetail && courseDetail.id) {
          res.id = courseDetail.id;
        }
        let data = {
          ...res,
          courseSectionList: list,
          waterMark: waterMark ? 1 : 0,
          /**针对国家级进行处理 */
          type: baseUserCategory !== "10" ? 1 : res.type,
          categoryInfo: category.name,
        };

        const { centerCategoryIdList, subjectIdList } = res;
        if (subjectIdList) {
          const [firstSubjectId, secondSubjectId, thirdSubjectId] =
            subjectIdList;
          data["firstSubjectId"] = firstSubjectId;
          data["secondSubjectId"] = secondSubjectId;
          data["thirdSubjectId"] = thirdSubjectId;
        }
        if (centerCategoryIdList) {
          const [firstCenterCategoryId, secondCenterCategoryId] =
            centerCategoryIdList;
          data["firstCenterCategoryId"] = firstCenterCategoryId;
          data["secondCenterCategoryId"] = secondCenterCategoryId;
        }

        saveCourse(data).then((res) => {
          message.success("保存成功");
          props.getCourseList && props.getCourseList();
          props.setIseditorCourseVisible(false);
        });
      })
      .catch((err) => {
        console.log(err);
        message.error(err.errorFields[0].errors[0]);
      });
  };
  /**
   * 处理专项数据
   * @param data
   * @returns
   */
  const handleSpecialData = (data: any) => {
    return data.map(
      (item: {
        key: number;
        parentId: number;
        title: string;
        children: any[];
      }) => {
        return {
          value: item.key,
          title: item.title,
          parentId: item.parentId,
          children: item.children ? handleSpecialData(item.children) : [],
        };
      }
    );
  };
  /**
   * 获取专项分类数据
   */
  const getSpecialClassificationData = async () => {
    const { data = [] } = await querySpecialClassificationData();
    setTreeData(handleSpecialData(data));
  };
  useEffect(() => {
    getSpecialClassificationData();
  }, []);
  useEffect(() => {
    base64Image = null;

    selectTeacher().then((res) => {
      setTeacherList(res.data);
    });

    selectTag().then((res) => {
      setTagList(res.data);
    });

    const editor = new E("#courseDetail");
    editor.config.onchange = function (newHtml: string) {
      form.setFieldsValue({
        content: newHtml,
      });
    };

    editor.config.customUploadImg = function (
      resultFiles: any,
      insertImgFn: any
    ) {
      let formData = new FormData();
      formData.append("file", resultFiles[0]);
      formData.append("uploadDataType", "image");
      formData.append("folder", "liveActivity");

      uploadFile(formData).then((res) => {
        insertImgFn(res.shortUrl);
      });
    };

    editor.create();
    editor.txt.html("");

    if (courseDetail) {
      editor.txt.html(courseDetail.content);
      setWaterMark(courseDetail.waterMark);
      setCourseSectionList(courseDetail.courseSectionList);
      const {
        firstCenterCategoryId,
        secondCenterCategoryId,
        firstSubjectId,
        secondSubjectId,
        thirdSubjectId,
        playCountType,
        playCount,
        centerCategoryNameList,
        subjectNameList,
      } = courseDetail;
      const centerCategoryIdList = [
        firstCenterCategoryId,
        secondCenterCategoryId,
      ];
      const subjectIdList = [firstSubjectId, secondSubjectId, thirdSubjectId];
      console.log("subjectIdList", subjectIdList);

      form.setFieldsValue({
        name: courseDetail.name,
        tagInfo: courseDetail.tagInfo,
        centerCategoryIdList,
        image: courseDetail.image,
        teacherIdList: courseDetail.teacherIdList,
        showOrder: courseDetail.showOrder,
        content: courseDetail.content,
        introduction: courseDetail.introduction,
        subjectIdList,
        type: courseDetail.type,
        categoryId: courseDetail.categoryId,
        playCountType,
        playCount,
        centerCategoryNameList,
        subjectNameList,
      });
      //自动设置，播放次数不能编辑
      if (playCountType === 2) {
        setLiveCountAutoSet(true);
      }
      /**保存专项的value和中文名称 */
      setCategory({
        name: courseDetail.categoryInfo,
        value: courseDetail.categoryId,
      });
      /**设置课程类型 */
      setCourseType(courseDetail.type);
      courseware.setFieldsValue({
        courseSectionList: courseDetail.courseSectionList,
      });

      originalImage = {
        shortUrl: courseDetail.originalImage,
        url: courseDetail.originalImageAllPath,
        initImage: courseDetail.imageAllPath,
      };
      setOriginalLogo(courseDetail.imageAllPath);

      // getBase64Image(courseDetail.originalImageAllPath).then((base) => {
      //   base64Image = base.data;
      //   if (originalImage) {
      //     originalImage.base64 = base.data;
      //   }
      //   setOriginalLogo(base.data);
      //   if (courseDetail.waterMark) {
      //     watermaskChange(true, base.data);
      //   }
      // });
    } else {
      setDefaultCourseImg();
    }
  }, []);
  /**
   * 设置默认图片
   */
  const setDefaultCourseImg = async () => {
    let {
      data: { originalImage: shortUrl, originalImageAllPath },
    } = await getCourseDefaultImg();
    originalImage = {
      shortUrl,
      url: originalImageAllPath,
      initImage: originalImageAllPath,
    };
    setOriginalLogo(originalImageAllPath);
  };
  /**
   * 通过parentId获取name拼接
   * @param parentId
   * @returns
   */
  const searchParentNameByCategoryData = (parentId: number) => {
    // @ts-ignore
    return treeData.find((item: { value: number }) => item.value === parentId)
      .title;
  };
  /**设置专项分类的值 */
  const onTreeSelect = (value: string, name: any) => {
    console.log("name", name);
    console.log("treeData", treeData);

    setCategory({
      value,
      name: `${searchParentNameByCategoryData(name.parentId)}/${name.title}`,
    });
  };
  return (
    <>
      <Modal
        title={courseDetail && courseDetail.id ? "编辑课程" : "新建课程"}
        width={980}
        visible={true}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose={true}
      >
        <h3 className="creatcourse-title">基本信息</h3>
        <Form
          form={form}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          scrollToFirstError={true}
          initialValues={{
            questionnaireId: 0,
            playCountType: 1,
            playCount: 0,
          }}
        >
          <Form.Item
            label="课程名称"
            name="name"
            rules={[
              {
                required: true,
                message: "请输入课程名称",
              },
            ]}
          >
            <Input onChange={onNameChange} />
          </Form.Item>
          {/* 只有国家级才有课程类型框，其他默认传1 */}
          {baseUserCategory === "10" && (
            <Form.Item
              label="课程类型"
              name="type"
              rules={[
                {
                  required: true,
                  message: "请选择课程类型",
                },
              ]}
            >
              <Select
                onChange={(val) => {
                  setCourseType(val);
                }}
              >
                <Option value={1}>临床课程</Option>
                <Option value={2}>专项课程</Option>
              </Select>
            </Form.Item>
          )}
          {courseType === 2 && (
            <Form.Item
              label="专项分类"
              name="categoryId"
              rules={[
                {
                  required: true,
                  message: "请选择专项分类",
                },
              ]}
            >
              <TreeSelect
                showSearch
                style={{ width: "100%" }}
                placeholder="请选择专项分类"
                value={category.value}
                onSelect={onTreeSelect}
                allowClear
                treeDefaultExpandAll
                treeData={treeData}
              />
            </Form.Item>
          )}
          {courseType === 1 && (
            <Form.Item
              label="标签"
              name="tagInfo"
              rules={[
                {
                  required: true,
                  message: "请选择标签",
                },
              ]}
            >
              <Select
                style={{ width: "100%" }}
                placeholder="请选择标签"
                showSearch={true}
              >
                {tagList.map(
                  (item: { id: string; tagName: string }, index: number) => {
                    return (
                      <Option value={item.tagName} key={index}>
                        {item.tagName}
                      </Option>
                    );
                  }
                )}
              </Select>
            </Form.Item>
          )}
          {(isCountyProject === "0" ||
            baseUserCategory === "10" ||
            baseUserCategory === "19") &&
            courseType === 1 && (
              <Form.Item
                label="中心分类"
                name="centerCategoryIdList"
                rules={[
                  {
                    required: true,
                    message: "请选择中心分类",
                  },
                ]}
              >
                <Cascader
                  options={categoryTree}
                  placeholder="请选择中心分类"
                  onChange={(value, selectedOptions) => {
                    console.log("selectedOptions", selectedOptions);

                    form.setFieldsValue({
                      centerCategoryNameList: [
                        selectedOptions[0].label,
                        selectedOptions[1].label,
                      ],
                    });
                  }}
                />
                {/* <Select
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder="请选择中心分类"
                >
                  {centerClassification.map(
                    (item: { id: string; name: string }, index: number) => {
                      return (
                        <Option value={item.id} key={index}>
                          {item.name}
                        </Option>
                      );
                    }
                  )}
                </Select> */}
              </Form.Item>
            )}
          <Form.Item name="subjectNameList" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="centerCategoryNameList" hidden>
            <Input />
          </Form.Item>
          {courseType === 1 && (
            <Form.Item
              label="学科分类"
              name="subjectIdList"
              rules={[
                {
                  required: true,
                  message: "请选择学科分类",
                },
              ]}
            >
              <Cascader
                options={subjectTree}
                placeholder="请选择所在学科"
                onChange={(value, selectedOptions) => {
                  form.setFieldsValue({
                    subjectNameList: [
                      selectedOptions[0].label,
                      selectedOptions[1].label,
                      selectedOptions[2].label,
                    ],
                  });
                }}
              />
            </Form.Item>
          )}
          <Form.Item label="课程封面" name="image" valuePropName="fileList">
            <>
              <Input type="hidden" />
              {originalLogo && <img src={originalLogo} alt="" />}
              <Upload
                className="course-uploader"
                showUploadList={false}
                customRequest={uploadChange}
              >
                <p>* 支持2M以内JPG、PNG，请上传宽469px、高300px的图片</p>
                <Button>选择文件</Button>
              </Upload>
            </>
          </Form.Item>
          <Form.Item label="水印">
            <Switch
              checkedChildren="开启"
              unCheckedChildren="关闭"
              checked={waterMark}
              onChange={(checked) => {
                setWaterMark(checked);
                if (originalImage === null) return;

                if (checked) {
                  watermaskChangeBefore(checked);
                } else {
                  form.setFieldsValue({ image: originalImage.shortUrl });
                  getBase64Image(originalImage.url).then((base) => {
                    base64Image = base.data;
                    setOriginalLogo(base.data);
                  });
                }
              }}
            />
          </Form.Item>
          <Form.Item label="选择讲师" name="teacherIdList">
            <Select style={{ width: "100%" }} placeholder="请选择讲师">
              {teacherList.map(
                (item: { id: string; name: string }, index: number) => {
                  return (
                    <Option value={item.id} key={index}>
                      {item.name}
                    </Option>
                  );
                }
              )}
            </Select>
          </Form.Item>
          <Form.Item
            label="播放次数设置"
            name="playCountType"
            rules={[{ required: true, message: "请选择播放次数设置!" }]}
          >
            <Radio.Group
              onChange={(e) => {
                setLiveCountAutoSet(e.target.value === 1 ? false : true);
                // e.target.value === 2 && form.setFieldsValue({ playCount: 0 });
              }}
            >
              <Radio value={1}>手工设置</Radio>
              <Radio value={2}>自动设置</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="播放次数"
            name="playCount"
            rules={[{ required: true, message: "请输入播放次数!" }]}
          >
            <InputNumber min={0} disabled={liveCountAutoSet} />
          </Form.Item>
          <Form.Item
            label="课程排序"
            name="showOrder"
            rules={[
              {
                required: true,
                message: "请选择课程排序",
              },
            ]}
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item
            label="课程详情"
            name="content"
            rules={[
              {
                required: true,
                message: "请填写课程详情",
              },
            ]}
          >
            <div id="courseDetail"></div>
          </Form.Item>
          <Form.Item
            label="课程简介"
            name="introduction"
            help="用于课程分享展示"
          >
            <TextArea />
          </Form.Item>
        </Form>
        <h3 className="creatcourse-title">课件信息</h3>
        <Form
          form={courseware}
          scrollToFirstError={true}
          className="coursewareInfo"
          initialValues={{
            remember: true,
          }}
        >
          <Form.List name="courseSectionList" initialValue={courseSectionList}>
            {(fields, { add, remove, move }) => {
              return (
                <React.Fragment>
                  <Button type="dashed" onClick={() => add()}>
                    新建课程
                  </Button>
                  {fields.map((item, index) => {
                    return (
                      <div className="creatcourse-courseware" key={index}>
                        <div className="creatcourse-courseware-index">
                          {`课件${index + 1}：`}
                        </div>
                        <div className="creatcourse-courseware-form">
                          <Form.Item>
                            <Select
                              placeholder="视频课件"
                              disabled={true}
                            ></Select>
                          </Form.Item>
                          <Form.Item name={[item.name, "name"]}>
                            <Input placeholder="请输入课件名称" />
                          </Form.Item>
                          <Form.Item name={[item.name, "videoName"]}>
                            <Input disabled={true} />
                          </Form.Item>
                        </div>
                        <div className="creatcourse-courseware-selcetvideo">
                          <Button
                            type="primary"
                            onClick={() => {
                              onSelectVideoClickHandle(item, index);
                            }}
                          >
                            选择视频
                          </Button>
                        </div>
                        <div className="creatcourse-courseware-options">
                          <Space>
                            <Button
                              icon={<ArrowDownOutlined />}
                              onClick={() => {
                                move(index, index + 1);
                              }}
                            />
                            <Button
                              icon={<ArrowUpOutlined />}
                              onClick={() => {
                                move(index, index - 1);
                              }}
                            />
                            <Button
                              icon={<DeleteOutlined />}
                              onClick={() => {
                                remove(index);
                              }}
                            />
                          </Space>
                        </div>
                      </div>
                    );
                  })}
                </React.Fragment>
              );
            }}
          </Form.List>
        </Form>
      </Modal>
      {isCheckVideoVisible && (
        <CheckVideo
          courseSectionIndex={courseSectionIndex}
          onSelectVideoCallback={onSelectVideoCallback}
          setIsCheckVideoVisible={setIsCheckVideoVisible}
        />
      )}
    </>
  );
};
